import React, { useState, useEffect } from 'react'

import { StyleSheet, View, ScrollView } from 'react-native'

import { SafeAreaView } from 'react-native-safe-area-context'

import {
    Text,
    Space,
    KeyboardAvoidingView,
    Button,
    TextFromCamera
} from '@sart/components'

import {
    INE,
    UkDrivingLicence
} from '@sart/schemas'

import { adaptive, backgroundColors, colors, typography } from '@sart/styles'
import { useContent } from '@sart/content'
import * as theme from './signTheme'

export default function Scanner(props) {
    const { navigation, route } = props
    useEffect(() => {
        const timer = setTimeout(() => {
            setDocumentTypeTimeout(true)
        }, 5000);
        return () => clearTimeout(timer);
    }, []);
    
    const content = useContent()
    const [canDetectText, setCanDetectText] = useState(true)
    const [textBlocks, setTextBlocks] = useState([])
    const [type, setType] = useState(undefined)
    const enteredEmail = route.params?.enteredEmail
    const enteredValues = route.params?.enteredValues
    const [documentTypeTimeout, setDocumentTypeTimeout] = useState(false)
    let scannedInfo = enteredValues;

    const ineRegex = new RegExp(/CREDENCIAL PARA VOTAR/)
    const UkDrivingLicenceRegex = new RegExp(/DRIVING LICENCE/)
    const [cameraInfo, setCameraInfo] = useState(undefined)
    const [scannedIneCustomerInfo, setScannedIneCustomerInfo] = useState({
        dobDay: undefined,
        dobMonth: undefined,
        dobYear: undefined,
        firstName: undefined,
        lastName: undefined,
        address1: undefined,
        address2: undefined,
        postcode: undefined,
        city: undefined,
        county: undefined
    })
    
    const [scannedUkDlCustomerInfo, setScannedUkDlCustomerInfo] = useState({
        dobDay: undefined,
        dobMonth: undefined,
        dobYear: undefined,
        firstName: undefined,
        lastName: undefined,
        address1: undefined,
        city: undefined
    })
    
    function setInfoFromScan(infoFromScan, idType) {
        var toReturn = {}
        Object.keys(infoFromScan).forEach(function (key) {
            if (infoFromScan && infoFromScan[key] !== undefined && idType == 'INE') {
                setScannedIneCustomerInfo({ ...scannedIneCustomerInfo, ...infoFromScan })
                setCameraInfo({ ...scannedIneCustomerInfo, ...infoFromScan })
                toReturn = ({ ...scannedIneCustomerInfo, ...infoFromScan })
            } else if (infoFromScan && infoFromScan[key] !== undefined && idType == 'UkDrivingLicence') {
                setScannedUkDlCustomerInfo({ ...scannedUkDlCustomerInfo, ...infoFromScan })
                setCameraInfo({ ...scannedUkDlCustomerInfo, ...infoFromScan })
                toReturn = ({ ...scannedUkDlCustomerInfo, ...infoFromScan })
            }
        });
        return toReturn
    }

    const textRecognized = object => {
        const { textBlocks } = object;
        let idType = ''
        setTextBlocks(textBlocks);
        var fullText = []
        
        textBlocks.forEach(readText => {
            fullText.push(readText.text)
        })

        fullText.forEach(element => {
            if (!type || type === undefined || type === null) {
                if (element.match(ineRegex)) {
                    setType('INE')
                    idType = 'INE'
                } else if (element.match(UkDrivingLicenceRegex)) {
                    setType('UkDrivingLicence')
                    idType = 'UkDrivingLicence'
                } else {
                }
            }
        });
        var scannedTempInfo = {}
        var scannedIdInfo = {}
        // Seting temperory info to state for saving        
        if (idType === 'INE') {
            scannedTempInfo = INE(fullText)
            scannedIdInfo = setInfoFromScan(scannedTempInfo, idType)
        } else if (idType === 'UkDrivingLicence') {
            scannedTempInfo = UkDrivingLicence(fullText)
            scannedIdInfo = setInfoFromScan(scannedTempInfo, idType)
        }
        
        //Setting if IDs are validated (If all information has been gotten). If any prop is empty, customer info is set as false. 
        let ineValidated = true;
        for (const prop in scannedIdInfo) {
            if ((idType === 'INE') && (!scannedIdInfo[prop] || scannedIdInfo[prop] === scannedIdInfo || scannedIdInfo[prop] === '')) {
                ineValidated = false
                break;
            }
        }
        
        let ukDlValidated = true;
        for (const prop in scannedIdInfo) {
            if ((idType === 'UkDrivingLicence') && (!scannedIdInfo[prop] || scannedIdInfo[prop] === scannedIdInfo || scannedIdInfo[prop] === '')) {
                ukDlValidated = false
                break;
            }
        }
        
        // Navigating to customer details form with populated information
        if (ineValidated || ukDlValidated) {
            // console.log('validated');
            // console.log('scannedIneCustomerInfo is: ');
            if(idType === 'INE') {
                scannedInfo = {...enteredValues, ...scannedIdInfo}
            }
            else if(idType === 'UkDrivingLicence') {
                scannedInfo = {...enteredValues, ...scannedIdInfo}
            }
            setTimeout(function () {
                navigation.navigate('SignUpNewCustomerDetails', { scannedCustomerInfo: scannedInfo })
            }, 250);
        }
    };

    return (
        <ScrollView style={styles.scrollViewContainer}>
            <SafeAreaView style={styles.container}>

                <KeyboardAvoidingView style={styles.content}>
                    <Space height={24} />

                    <View>
                        <TextFromCamera
                            style={{ height: 520, width: '100%' }}
                            androidCameraPermissionOptions={{
                                title: 'Permission to use camera',
                                message: 'We need your permission to use your camera',
                                buttonPositive: 'Ok',
                                buttonNegative: 'Cancel',
                            }}
                            onTextRecognized={textRecognized}
                            captureAudio={false}
                            scannedInfo={cameraInfo}
                            overlayWidth={'95%'}
                            overlayHeight={'45%'}
                        />
                    </View>

                    <Space height={24} />

                    {type === undefined && documentTypeTimeout &&
                        <Text {...theme.title}>{content.register_new_customer.unrecognisedId}</Text>
                    }

                    <Space height={24} />

                    <Button
                        title={content.camera_components.cancel_scanning}
                        style={styles.button}
                        onPress={() => navigation.navigate('SignUpNewCustomerDetails', { scannedCustomerInfo: {...enteredValues, ...cameraInfo}, email: enteredEmail })}
                    />
                    <Space height={12} />
                </KeyboardAvoidingView>
            </SafeAreaView>
        </ScrollView>
    )
}

const styles = StyleSheet.create({
    scrollViewContainer: {
        flex: 1,
        backgroundColor: backgroundColors.srGreen,
    },
    container: {
        flex: 1,
        backgroundColor: backgroundColors.srGreen
    },
    content: {
        // flex: 1,
        ...adaptive.wrapperPadding,
        justifyContent: 'center',
        // ...adaptive.loginContentHeight
    },
    description: {
        textAlign: 'center',
        ...typography.demi,
        color: colors.srTextInput
    },
    link: {
        color: colors.clear
    },
    forgottenPassword: {
        color: colors.srTextInput
    },
    spaceHeightOne: {
        ...adaptive.spaceHeightLoginScreenOne
    },
    spaceHeightTwo: {
        ...adaptive.spaceHeightLoginScreenTwo
    },
    spaceHeightTop: {
        ...adaptive.spaceHeightLoginScreenTop
    },
    text: {
        fontSize: 30,
        color: 'green',
        ...typography.bold,
        textAlign: 'center',
        justifyContent: 'flex-start'
    },
    button: {
        backgroundColor: colors.srDarkGreen
    }
})

